// chart
import Vue from 'vue'

import antTable from '@/components/Table/antTable'
import Map from '@/components/map/index'
import Table from '@/components/Table'
import SimpleTable from '@/components/Table/simpleTable'
import PtTableHeader from '@/components/Table/tableHeader'
import TableHeader from '@/components/tableHeader'
import Modal from '@/components/modal'
import Search from '@/components/form/search'
import DrawerInfo from '@/components/drawerInfo'
import Icon from '@/components/Icon'
import OssUpload from '@/components/upload/ossUpload'
import LeftRightLayout from '@/components/LeftRightLayout'
import Pagination from '@/components/Pagination'
import Input from '@/components/form/input'
import DatePicker from '@/components/form/datePicker'
import MonthPicker from '@/components/form/monthPicker'
import monthRangePicker from '@/components/picker/monthRangePicker'
import PtSelectUser from '@/components/form/selectUser'
import PtUserSelect from '@/components/form/userSelect'
import PtUserSelectAll from '@/components/form/userSelectAll'
import PutUserSelectOrPutAll from '@/components/form/userSelectOrPutAll'
import PtAllUserSelect from '@/components/form/allUserSelect'
import PtCompanySelect from '@/components/form/companySelect'
import PtdictSelect from '@/components/form/dictSelect'
import PtFilterCompanySelect from '@/components/form/filterCompanySelect'
import PtStatisticsCompanySelect from '@/components/form/statisticsCompanySelect'
import Checkbox from '@/components/form/check'
import Select from '@/components/form/select'
import YearSelect from '@/components/form/yearSelect'
import MainBodySelect from '@/components/form/MainBodySelect'
import ptTag from '@/components/tag'
import addTag from '@/components/tag/addTag'
import newObjectTag from '@/components/tag/newObjectTag'
import closeTag from '@/components/tag/closeTag'
import Card from '@/components/card'
import ptCollapseIndustrial from '@/components/collapseIndustrial/index'
import InputNumber from '@/components/form/inputNumber'
import ptShowNumber from '@/components/AnimatedNumber/index'
import ptCascader from '@/components/form/cascader'
import ptMultiCascader from '@/components/form/multiCascader'
import PtList from '@/components/Table/PtList'
import PtUnitSelect from '@/components/form/unitSelect'
import PtHideContainer from '@/components/form/hideContainer'
import PtImage from '@/components/imageViewer'
import PtEmpty from '@/components/empty'
import PtSlider from '@/components/slider'
import linkmanTable from '@/components/linkmanTable'
import PtYearPicker from '@/components/form/ptYearPicker'
import PtMonthRangePicker from '@/components/form/monthRangePicker'
import PtQuarterRangePicker from '@/components/form/quarterRangePicker'
import TipModal from '@/components/modal/tipModal'
import QuillEditor from '@/components/Editor/QuillEditor'
import HistoryComment from '@/components/historyComment'
import ApsRule from '@/components/aps-rule/index'
Vue.component(Table.name,Table)
Vue.component(Map.name,Map)
Vue.component(QuillEditor.name,QuillEditor)
Vue.component(Card.name,Card)
Vue.component(TableHeader.name,TableHeader)
Vue.component(Input.name,Input)
Vue.component(Checkbox.name,Checkbox)
Vue.component(InputNumber.name,InputNumber)
Vue.component(PtSelectUser.name,PtSelectUser)
Vue.component(PtAllUserSelect.name,PtAllUserSelect)
Vue.component(ptShowNumber.name,ptShowNumber)
Vue.component(SimpleTable.name,SimpleTable)
Vue.component(HistoryComment.name,HistoryComment)
Vue.component(DatePicker.name,DatePicker)
Vue.component(PtMonthRangePicker.name,PtMonthRangePicker)
Vue.component(PtQuarterRangePicker.name,PtQuarterRangePicker)
Vue.component(MonthPicker.name,MonthPicker)
Vue.component(monthRangePicker.name,monthRangePicker)
Vue.component(Select.name,Select)
Vue.component(YearSelect.name,YearSelect)
Vue.component(PtUserSelect.name,PtUserSelect)
Vue.component(PtUserSelectAll.name,PtUserSelectAll)
Vue.component(PutUserSelectOrPutAll.name,PutUserSelectOrPutAll)
Vue.component(PtCompanySelect.name,PtCompanySelect)
Vue.component(PtdictSelect.name,PtdictSelect)
Vue.component(PtFilterCompanySelect.name,PtFilterCompanySelect)
Vue.component(PtStatisticsCompanySelect.name,PtStatisticsCompanySelect)
Vue.component(PtTableHeader.name,PtTableHeader)
Vue.component(PtYearPicker.name,PtYearPicker)
Vue.component('ant-table',antTable)
Vue.component('pt-icon',Icon)
Vue.component(Modal.name,Modal)
Vue.component('pt-drawer',DrawerInfo)
Vue.component('pt-oss-upload',OssUpload)
Vue.component('pt-search',Search)
Vue.component('pt-left-right-layout',LeftRightLayout)
Vue.component('pt-pagination',Pagination)
Vue.component('pt-tag',ptTag)
Vue.component('pt-addTag',addTag)
Vue.component('pt-closeTag',closeTag)
Vue.component('pt-newObjectTag',newObjectTag)
Vue.component('pt-cascader',ptCascader)
Vue.component('pt-multi-cascader',ptMultiCascader)
Vue.component(PtUnitSelect.name,PtUnitSelect)
Vue.component(ptCollapseIndustrial.name,ptCollapseIndustrial)
Vue.component(PtImage.name,PtImage)
Vue.component(PtEmpty.name,PtEmpty)
Vue.component(PtSlider.name,PtSlider)
Vue.component(linkmanTable.name,linkmanTable)
Vue.component(PtHideContainer.name,PtHideContainer)
Vue.component(TipModal.name,TipModal)
Vue.component(PtList.name,PtList)
Vue.component(ApsRule.name,ApsRule)
Vue.component(MainBodySelect.name,MainBodySelect)